import { FunctionalComponent, h } from "preact";
import SplitIcon from "./icons/SplitIcon";

const Footer: FunctionalComponent = () => {
  return (
    <footer class="shadow-lg bg:shadow-slate-900 p-5 mt-4">
      <a href="/privacy-policy">Privacy Policy</a>
    </footer>
  );
};

export default Footer;
